import React from "react";

export const Footer = () => (
  <footer className="bg-gray-900 text-gray-300 py-10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-8">
      <div>
        <a href="/" className="flex items-center space-x-3 mb-3" data-testid="footer-home-link">
          <div className="w-8 h-8 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-full flex items-center justify-center">
            <span className="text-white font-bold text-sm">C</span>
          </div>
          <span className="text-xl font-bold text-white">Culinera</span>
        </a>
        <p className="text-sm">Personalized Alberta culinary road trips — from Calgary fine dining to Banff mountaintop tasting menus.</p>
      </div>

      <div>
        <h4 className="text-white font-semibold mb-3">Explore</h4>
        <ul className="space-y-2 text-sm">
          <li><a data-testid="footer-wizard-link" href="/?view=wizard" className="hover:text-white">Plan a Trip</a></li>
          <li><a data-testid="footer-restaurants-link" href="/?view=restaurants" className="hover:text-white">Restaurant Directory</a></li>
          <li><a data-testid="footer-blog-link" href="/blog" className="hover:text-white">The Culinera Journal</a></li>
          <li><a data-testid="footer-samples-link" href="/sample-itineraries" className="hover:text-white">Sample Itineraries</a></li>
          <li><a data-testid="footer-submit-link" href="/submit-truck" className="hover:text-white">Submit Your Food Truck</a></li>
        </ul>
      </div>

      <div>
        <h4 className="text-white font-semibold mb-3">City Guides</h4>
        <ul className="space-y-2 text-sm">
          <li><a data-testid="footer-calgary-guide-link" href="/calgary-food-scene" className="hover:text-white">Calgary Food Scene</a></li>
          <li><a data-testid="footer-edmonton-guide-link" href="/edmonton-hidden-gems" className="hover:text-white">Edmonton Hidden Gems</a></li>
          <li><a data-testid="footer-banff-guide-link" href="/banff-dining-guide" className="hover:text-white">Banff Dining Guide</a></li>
          <li><a data-testid="footer-jasper-trip-link" href="/blog/5-day-calgary-to-jasper-food-road-trip-itinerary" className="hover:text-white">Calgary to Jasper Road Trip</a></li>
        </ul>
      </div>

      <div>
        <h4 className="text-white font-semibold mb-3">Company</h4>
        <ul className="space-y-2 text-sm mb-4">
          <li><a data-testid="footer-about-link" href="/about" className="hover:text-white">About</a></li>
          <li><a data-testid="footer-privacy-link" href="/privacy" className="hover:text-white">Privacy Policy</a></li>
          <li><a data-testid="footer-terms-link" href="/terms" className="hover:text-white">Terms of Service</a></li>
          <li><a data-testid="footer-contact-link" href="/contact" className="hover:text-white">Contact</a></li>
        </ul>
        <p className="text-sm">Email <a href="mailto:hello@culinera.ca" className="text-teal-400 hover:text-teal-300">hello@culinera.ca</a></p>
        <p className="text-xs text-gray-500 mt-3">© {new Date().getFullYear()} Culinera. Built for Alberta food lovers.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
